'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partial;

var _immutable = require('immutable');

var _lodash = require('lodash.partial');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function partial(func) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var key = _immutable.List.of.apply(_immutable.List, [func].concat(args));
  if (!this.__partials__.has(key)) {
    this.__partials__ = this.__partials__.set(key, _lodash2.default.apply(undefined, [func].concat(args)));
  }

  return this.__partials__.get(key);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-component-with-partials/lib/partial.js
// module id = KLto
// module chunks = 88